import { cn } from 'app/lib/utils';

interface LoaderProps {
  variant?: 'screen' | 'content' | 'inline';
  label?: string;
  className?: string;
}

const Loader = ({ variant = 'screen', label, className }: LoaderProps) => {
  return (
    <div
      className={cn(
        'flex items-center justify-center',
        variant === 'screen' && 'h-screen bg-white',
        variant === 'content' && 'absolute inset-0 z-20 bg-white/80',
        variant === 'inline' && 'inline-flex',
        className
      )}
      role={label ? 'status' : undefined}
    >
      <div
        className={cn(
          'animate-spin rounded-full border-4 border-solid border-blue-500 border-t-transparent',
          variant === 'screen' && 'h-16 w-16',
          variant === 'content' && 'h-12 w-12',
          variant === 'inline' && 'h-5 w-5 border-2'
        )}
      />
      {label && <span className="sr-only">{label}</span>}
    </div>
  );
};

export default Loader;
